<div *transloco="let t" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
	<div mat-dialog-title class="flex flex-col border-b pb-2 cursor-move" cdkDragHandle>
		<div class="flex items-center justify-between">
			<span class="text-xl font-semibold">{{ t('billing.periodCompletionDialogTitle') }}</span>
			<button mat-icon-button (click)="onCancel()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
		<div class="text-sm text-gray-600 font-normal">
			{{ t('billing.periodForTimeRange') }} [{{ dateUtil.setDateFormatByActiveLang(data.period.validFrom, '', false, true) }} -
			{{ dateUtil.setDateFormatByActiveLang(data.period.validTo, '', false, true) }}]
		</div>
	</div>

	<div mat-dialog-content class="mt-4">
		<mat-tab-group>
			<!-- Cost statement -->
			<mat-tab>
				<ng-template mat-tab-label>{{ t('billing.costList') }} ({{ costsCheckedCount }}/{{ costCheckboxTotal }})</ng-template>

				<div class="p-4 flex flex-col gap-2">
					<mat-checkbox [(ngModel)]="costGroupsCreated">
						{{ t('billing.costStatement.costGroupsCreated') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="costNamesUpToDate">
						{{ t('billing.costStatement.costNamesUpToDate') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="costAllocationKeysAssigned">{{ t('billing.costStatement.costAllocationKeysAssigned') }}</mat-checkbox>
					<mat-checkbox [(ngModel)]="costExceptionsAndFlatratesCreated">
						{{ t('billing.costStatement.costExceptionsAndFlatratesCreated') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="invoiceItemsCreated">
						{{ t('billing.costStatement.invoiceItemsCreated') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="invoicesCreated">
						{{ t('billing.costStatement.invoicesCreated') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="printOrderSorted">{{ t('billing.costStatement.printOrderSorted') }}</mat-checkbox>
					<mat-checkbox [(ngModel)]="costItemsValidated">
						{{ t('billing.costStatement.costItemsValidated') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="billingRemarksEntered">
						{{ t('billing.costStatement.billingRemarksEntered') }}
					</mat-checkbox>
				</div>
			</mat-tab>

			<!-- Billing settings -->
			<mat-tab>
				<ng-template mat-tab-label>{{ t('billing.billingSettings') }} ({{ settingsCheckedCount }}/{{ settingsCheckboxTotal }})</ng-template>

				<div class="p-4 flex flex-col gap-2">
					<mat-checkbox [(ngModel)]="countryRegulationsSelected">{{ t('billing.billingSettingsDialog.countryRegulationsSelected') }}</mat-checkbox>
					<mat-checkbox [(ngModel)]="taxSettingsConfigured">
						{{ t('billing.billingSettingsDialog.taxSettingsConfigured') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="co2CostActConfigured">{{ t('billing.billingSettingsDialog.co2CostActConfigured') }}</mat-checkbox>
					<mat-checkbox [(ngModel)]="idaSettingsConfigured">
						{{ t('billing.billingSettingsDialog.idaSettingsConfigured') }}
					</mat-checkbox>
				</div>
			</mat-tab>

			<!-- User data -->
			<mat-tab>
				<ng-template mat-tab-label>{{ t('billing.userData') }} ({{ userCheckedCount }}/{{ userCheckboxTotal }})</ng-template>

				<div class="p-4 flex flex-col gap-2">
					<mat-checkbox [(ngModel)]="occupantChangesRecorded">
						{{ t('billing.userDataDialog.occupantChangesRecorded') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="occupantSharesMaintained">
						{{ t('billing.userDataDialog.occupantSharesMaintained') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="occupantSelectionsMaintained">
						{{ t('billing.userDataDialog.occupantSelectionsMaintained') }}
					</mat-checkbox>
					<mat-checkbox [(ngModel)]="advancePaymentsRecorded">{{ t('billing.userDataDialog.advancePaymentsRecorded') }}</mat-checkbox>
					<mat-checkbox [(ngModel)]="occupantSettingsUpToDate">
						{{ t('billing.userDataDialog.occupantSettingsUpToDate') }}
					</mat-checkbox>
				</div>
			</mat-tab>
		</mat-tab-group>

		<div class="space-y-6">
			<!-- Important notice -->
			<div class="bg-amber-50 border-l-4 border-amber-400 p-4 mt-6">
				<div class="flex">
					<div class="flex-shrink-0">
						<mat-icon class="text-amber-400">warning</mat-icon>
					</div>
					<div class="ml-3">
						<h4 class="text-sm font-bold text-amber-800 uppercase tracking-wide">{{ t('billing.importantNoticeContent.title') }}</h4>
						<div class="mt-2 text-sm text-amber-700">
							<p>{{ t('billing.importantNoticeContent.mainText') }}</p>
							<p class="mt-3 font-medium">{{ t('billing.importantNoticeContent.alsoLocked') }}</p>
							<ul class="list-disc ml-5 mt-1 space-y-1">
								<li>
									<span class="font-medium">{{ t('billing.importantNoticeContent.from') }} {{ formattedLockDisplayDate }}:</span>
									{{ t('billing.importantNoticeContent.personOverviewLocked') }}
								</li>
								<li>
									<span class="font-medium">{{ t('billing.importantNoticeContent.from') }} {{ formattedLockDisplayDate }}:</span>
									{{ t('billing.importantNoticeContent.userDataLocked') }}
								</li>
							</ul>
							<p class="mt-3 font-medium">{{ t('billing.importantNoticeContent.confirmation') }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="ml-3">
				<h4 class="text-sm text-black font-bold uppercase tracking-wide">{{ t('billing.preliminaryData.title') }}</h4>
				<div class="mt-2 text-sm text-black">
					<p>
						{{ t('billing.preliminaryData.text') }}
					</p>
				</div>
				<button mat-raised-button [disabled]="true">
					<mat-icon fontSet="material-symbols-outlined" color="primary">download</mat-icon>
					<div>{{ t('billing.downloadPreliminaryData') }}</div>
				</button>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="flex flex-row justify-end gap-2 border-t p-4">
		<div class="w-1/2">
			<ara-drag-to-complete [disabled]="!allChecked || isSubmitting()" (completed)="lock()"></ara-drag-to-complete>
		</div>
	</div>
</div>
